"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var RetrieveCartState_1 = require("./RetrieveCartState");
require("./RetrieveCart.scss");
var ui_components_1 = require("@idp/ui-components");
var components_1 = require("@idp/duc/components");
var MessageProps_1 = require("@idp/ui-components/components/atoms/Message/MessageProps");
var ReportingService_1 = require("../../../../api/ReportingService");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var styles = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var TextFieldProps_1 = require("@idp/duc/components/atoms/TextField/TextFieldProps");
var StateProvider_1 = require("../../../../api/StateProvider");
var cms_integration_1 = require("@idp/cms-integration");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var Checkout_cms_1 = require("../../../../cms/Checkout.cms");
var utils_1 = require("@idp/ui-components/utils");
var Api_1 = require("../../../../api/Api");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var localStyles = require("./RetrieveCart.scss");
var Utils = require("../../../../utils/UtilityFunctions");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var RetrieveCartProps_1 = require("./RetrieveCartProps");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var components_2 = require("@idp/duc/components");
var RetrieveCart = /** @class */ (function (_super) {
    __extends(RetrieveCart, _super);
    function RetrieveCart(props) {
        var _this = _super.call(this, props) || this;
        _this.showMessage = false;
        _this.emptyCart = false;
        _this.emailFullRegex = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-][a-zA-Z0-9-]+\\.[a-zA-Z0-9-.][a-zA-Z0-9-.]+$');
        _this.requiredFieldText = 'Required field';
        _this.invalidCharText = 'Invalid character';
        _this.zipFlag = true;
        _this.state = new RetrieveCartState_1.default();
        _this.api = new Api_1.default();
        _this.initializeEvents();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.reportingService = new ReportingService_1.default();
        _this.onClose = _this.onClose.bind(_this);
        _this.showCartModal = _this.showCartModal.bind(_this);
        _this.seeModal = _this.seeModal.bind(_this);
        _this.signIn = _this.signIn.bind(_this);
        _this.showRetrieveErrorMsg = _this.showRetrieveErrorMsg.bind(_this);
        _this.zipCodeMismatch = _this.zipCodeMismatch.bind(_this);
        _this.submitZipCodeEvents = _this.submitZipCodeEvents.bind(_this);
        _this.getZipValue = _this.getZipValue.bind(_this);
        return _this;
    }
    RetrieveCart.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.data.triggerCart !== this.props.data.triggerCart) {
            this.setState({ showModal: nextProps.data.triggerCart });
        }
    };
    RetrieveCart.prototype.componentDidMount = function () {
        this.payload = Utils.getCartResp();
        if (this.payload) {
            this.emptyCart = false;
            this.showMessage = true;
        }
        else {
            this.emptyCart = true;
            this.showMessage = false;
        }
        if (this.props.data.triggerCart) {
            this.setState({ showModal: this.props.data.triggerCart });
        }
    };
    RetrieveCart.prototype.initializeEvents = function () {
        var _this = this;
        this.cancelEvent = {
            onClick: function () {
                _this.reportingService.fireLinkClickWithOutPageLoad(ReportingService_1.CheckoutLinkNames.MODAL_CLOSE, ReportingService_1.PageUrls.CART_PAGE);
                _this.setState({
                    canBeCollapsed: true,
                    email: '',
                    isEmailinValid: false,
                    isSubmitBtnDisabled: true,
                    showModal: false,
                });
                if (_this.props && _this.props.events) {
                    _this.props.events.onModalClose();
                }
            },
        };
        this.emailEvents = {
            onBlur: function (value) {
                _this.emailEventsBlurActions(value);
            },
            onChange: function (event) {
                _this.setState({
                    email: event.currentTarget.value,
                    emailErrTxt: '',
                    isEmailinValid: false,
                }, function () {
                    _this.checkContactFormValidOrNot();
                });
            },
            onClear: function (value, event) {
                _this.setState({
                    email: '',
                    emailErrTxt: '',
                    isEmailinValid: false,
                }, function () {
                    _this.checkContactFormValidOrNot();
                });
            },
            onKeyPress: function (value, e) {
                _this.emailEventsKeyPressActions(value, e);
            },
        };
        this.onRadioGroupChange = {
            onChange: function (value) {
                _this.setState({
                    currentValue: value,
                    isSubmitBtnDisabled: false,
                });
            },
        };
    };
    RetrieveCart.prototype.render = function () {
        this.retrieveCarttext = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common.saveRetrieveCart;
        this.commonFieldsCmsData = cms_integration_1.CMS.get(new Checkout_cms_1.CheckoutCms(), 'cartcheckout').content.commonFields;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null, !this.props.data.triggerCart &&
                React.createElement(components_1.Link, { kind: "textPlain", testId: 'Retrieve Cart', className: CartConfiguration_scss_1.cartLinkMedium, onClick: this.seeModal.bind(this, this.retrieveCarttext.retrieve.titleLabel) }, this.retrieveCarttext.retrieve.titleLabel)),
            this.zipFlag && this.zipCodeMismatch()));
    };
    RetrieveCart.prototype.seeModal = function (linkName) {
        this.reportingService.fireLinkClickWithOutPageLoad(linkName, ReportingService_1.PageUrls.RETRIEVE_CART_URL);
        this.setState({ showModal: true });
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.RETRIEVE_CART_URL);
    };
    RetrieveCart.prototype.signIn = function (linkName) {
        this.reportingService.fireLinkClickWithOutPageLoad(linkName, ReportingService_1.PageUrls.SIGN_IN);
        setTimeout(function () {
            window.open('https://www.att.com/shop/login/login.html?retrievecart=true', '_blank');
        }, 3000);
    };
    RetrieveCart.prototype.showCartModal = function () {
        var _this = this;
        this.payload = Utils.getCartResp();
        var emailLabel = 'Email address';
        this.emptyCart = true;
        var authUser = false;
        if (this.payload) {
            this.emptyCart = false;
            if (this.payload.authUser) {
                authUser = true;
            }
        }
        return (React.createElement("div", null,
            React.createElement(ui_components_1.Modal, { testId: 'Modal_Legal_Content', options: { center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.showModal, showClose: true }, events: { onClose: this.onClose }, accessibilityText: "_Retrieve_Cart" },
                React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { text: this.retrieveCarttext.retrieve.titleLabel }, options: { className: CartConfiguration_scss_1.rennyModalTitle } })),
                    (this.showMessage || this.state.isError) &&
                        this.showRetrieveErrorMsg(),
                    (!authUser || this.emptyCart) &&
                        React.createElement("div", null,
                            React.createElement("div", null,
                                React.createElement("div", { className: localStyles.existdescLabel },
                                    React.createElement(ui_components_1.Label, { data: { text: this.retrieveCarttext.retrieve.descLabel }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING15 } })),
                                React.createElement("div", { className: localStyles.signInLabel },
                                    React.createElement(components_1.Link, { kind: "textPlain", testId: 'Sign_In', onClick: this.signIn.bind(this, this.retrieveCarttext.retrieve.signInLabel) }, this.retrieveCarttext.retrieve.signInLabel),
                                    React.createElement(ui_components_1.Label, { data: { text: this.retrieveCarttext.retrieve.descSignInLabel }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } })),
                                React.createElement("div", { className: localStyles.enterLabelEmail },
                                    React.createElement(ui_components_1.Label, { data: { text: this.retrieveCarttext.retrieve.enterEmailLabel }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } }))),
                            React.createElement("div", { id: "email", className: [localStyles.emailContainer,
                                    this.state.isEmailinValid ? styles.showErrMsg : ''].join(' ') },
                                React.createElement(ui_components_1.Label, { testId: 'email_Label', data: { text: this.retrieveCarttext.retrieve.emailLabel }, options: { className: styles.labelBold, size: LabelProps_1.LabelSizes.MEDIUMBODYALTERNATE } }),
                                React.createElement("div", { className: [styles.posRel, styles.textTipSpace].join(' ') },
                                    React.createElement(components_1.TextField, { testId: 'email_TextField', data: { input: this.state.email }, events: this.emailEvents, options: {
                                            accessibility: emailLabel, maxLength: 64,
                                            type: TextFieldProps_1.TextFieldType.TEXT, withTooltip: false,
                                        } })),
                                React.createElement("div", { className: styles.errTxt },
                                    React.createElement("i", { "aria-label": this.commonFieldsCmsData.iconAccessibilityAriaLabel, className: [icons.cccIconCart, icons.cccIconCartBadgealert].join(' '), "aria-hidden": "true" }),
                                    React.createElement("span", { "aria-live": "assertive", role: "alert" }, this.state.emailErrTxt)),
                                React.createElement("div", { className: localStyles.retrieveButton },
                                    React.createElement(ui_components_1.Button, { data: {
                                            disabled: this.state.isSubmitBtnDisabled,
                                            text: this.retrieveCarttext.retrieve.titleLabel,
                                        }, events: {
                                            onClick: function () {
                                                _this.submitRetrieve(_this.state.email, _this.retrieveCarttext.retrieve.titleLabel);
                                            },
                                        }, options: { className: localStyles.buttonSize }, testId: utils_1.default('Button', '_contactInfo_Button') }),
                                    React.createElement(ui_components_1.Button, { data: { text: this.retrieveCarttext.retrieve.cancelCTALabel }, events: this.cancelEvent, testId: utils_1.default('Link', '_cancel_Link'), options: {
                                            className: localStyles.buttonSize,
                                        } })))),
                    authUser &&
                        React.createElement("div", null,
                            React.createElement("div", { className: localStyles.existdescLabel },
                                React.createElement(components_2.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'Retrieve_Error_', '_msg'), type: "info" },
                                    React.createElement(ui_components_1.Label, { data: {
                                            text: (this.emptyCart ?
                                                this.retrieveCarttext.retrieve.noCartSavedAuthErrTxt
                                                : this.retrieveCarttext.retrieve.activeCartErrTxt),
                                        }, options: {
                                            size: LabelProps_1.LabelSizes.MEDIUM,
                                        } })),
                                React.createElement("div", { className: localStyles.retrieveButton },
                                    React.createElement(ui_components_1.Button, { data: {
                                            disabled: false,
                                            text: (this.emptyCart ?
                                                this.retrieveCarttext.retrieve.shoppingCTALabel
                                                : this.retrieveCarttext.retrieve.titleLabel),
                                        }, events: {
                                            onClick: function () {
                                                _this.submitRetrieve(_this.state.email, _this.emptyCart ?
                                                    _this.retrieveCarttext.retrieve.shoppingCTALabel
                                                    : _this.retrieveCarttext.retrieve.titleLabel);
                                            },
                                        }, options: { className: localStyles.buttonSize }, testId: utils_1.default('Button', '_contactInfo_Button') }),
                                    React.createElement(ui_components_1.Button, { data: { text: this.retrieveCarttext.retrieve.cancelCTALabel }, events: this.cancelEvent, testId: utils_1.default('Link', '_cancel_Link'), options: {
                                            className: localStyles.buttonSize,
                                        } }))))))));
    };
    RetrieveCart.prototype.emailEventsBlurActions = function (value) {
        var _this = this;
        if (value) {
            value = value.trim();
            if (!this.emailFullRegex.test(value)) {
                this.setState({ isEmailinValid: true, emailErrTxt: 'Enter a valid email address' });
            }
            else {
                this.setState({
                    email: value, emailErrTxt: '',
                    emailUpdated: true, isEmailinValid: false,
                }, function () {
                    _this.checkContactFormValidOrNot();
                });
            }
        }
        else {
            this.setState({ isEmailinValid: true, emailErrTxt: this.requiredFieldText });
        }
    };
    RetrieveCart.prototype.emailEventsKeyPressActions = function (value, e) {
        var regex = new RegExp('^[\\w-_.@]$');
        if (!regex.test(e.key)) {
            this.setState({ isEmailinValid: true, emailErrTxt: this.invalidCharText });
            e.preventDefault();
        }
        else {
            this.setState({ isEmailinValid: false, emailErrTxt: '' });
        }
    };
    RetrieveCart.prototype.submitRetrieve = function (value, linkName) {
        return __awaiter(this, void 0, void 0, function () {
            var emailData_1;
            var _this = this;
            return __generator(this, function (_a) {
                if (value && value.trim() !== '') {
                    emailData_1 = {
                        email: value,
                    };
                    this.reportingService.fireRetrieveCartResponseEvent(false, undefined, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, linkName, emailData_1.email);
                    this.api.retrieveCart(emailData_1).then(function (response) {
                        if (response && response.content && response.content.payload &&
                            response.content.payload.retrieveURL) {
                            _this.reportingService.fireRetrieveCartResponseEvent(false, undefined, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkName, emailData_1.email);
                            _this.setState({ showModal: false, retrieveCartApiIsError: false });
                            window.location.href = response.content.payload.retrieveURL;
                        }
                        else {
                            if (response && response.error && response.error.errorId) {
                                _this.errorcode = response.error.errorId;
                                _this.apierrormsg = response.error.message;
                                _this.reportingService.fireRetrieveCartResponseEvent(true, _this.apierrormsg, _this.errorcode, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkName, emailData_1.email);
                            }
                            _this.setState({
                                isError: true,
                                isSubmitBtnDisabled: true,
                                retrieveCartApiIsError: true,
                            });
                        }
                        _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.RETRIEVE_CART_URL);
                    }).catch(function (err) {
                        _this.errorcode = '00000';
                        _this.setState({
                            isError: true,
                            isSubmitBtnDisabled: true,
                            retrieveCartApiIsError: true,
                        });
                        _this.reportingService.fireRetrieveCartResponseEvent(true, JSON.stringify(err), err && err.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, linkName, emailData_1.email);
                    });
                    this.setState({ email: '', isSubmitBtnDisabled: true });
                }
                else {
                    this.setState({ isEmailinValid: true, emailErrTxt: this.requiredFieldText });
                }
                return [2 /*return*/];
            });
        });
    };
    RetrieveCart.prototype.onClose = function () {
        this.reportingService.fireLinkClickWithOutPageLoad(ReportingService_1.CheckoutLinkNames.MODAL_CLOSE, ReportingService_1.PageUrls.CART_PAGE);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        this.setState({
            canBeCollapsed: true,
            email: '',
            isEmailinValid: false,
            isSubmitBtnDisabled: true,
            showModal: false,
        });
        if (this.props && this.props.events) {
            this.props.events.onModalClose();
        }
    };
    RetrieveCart.prototype.checkContactFormValidOrNot = function () {
        if (this.state.email
            && this.emailFullRegex.test(this.state.email)) {
            this.setState({ isSubmitBtnDisabled: false });
        }
        else {
            this.setState({ isSubmitBtnDisabled: true });
        }
    };
    RetrieveCart.prototype.showRetrieveErrorMsg = function () {
        if (this.state.retrieveCartApiIsError) {
            var msgText = this.retrieveCarttext.retrieveYourCartErrTxt || this.apierrormsg;
            var iconType = MessageProps_1.MessageType.ERROR;
            if (this.errorcode === 'Cart-RC-1028') {
                msgText = this.retrieveCarttext.retrieveYourCartRC1028ErrTxt;
                iconType = MessageProps_1.MessageType.INFO;
            }
            else if (this.errorcode === 'Cart-RC-1029') {
                msgText = this.retrieveCarttext.retrieveYourCartRC1029ErrTxt;
                iconType = MessageProps_1.MessageType.INFO;
            }
            else if (this.errorcode === 'Cart-RC-1030') {
                msgText = this.retrieveCarttext.retrieveYourCartErrTxt;
                iconType = MessageProps_1.MessageType.ERROR;
            }
            else if (this.errorcode === 'Cart-RC-1031') {
                msgText = this.retrieveCarttext.retrieveYourCartRC1031ErrTxt;
                iconType = MessageProps_1.MessageType.INFO;
            }
            return (React.createElement("div", { className: localStyles.errMessage },
                React.createElement(components_2.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'Retrieve_Error_', '_msg'), type: iconType === MessageProps_1.MessageType.INFO ? 'info' : 'error' },
                    React.createElement(ui_components_1.Label, { data: { text: msgText }, options: { size: LabelProps_1.LabelSizes.MEDIUM } }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    RetrieveCart.prototype.getZipValue = function (cookieVal) {
        var decodedCookie = cookieVal.split('|');
        var newdecodedCookie;
        decodedCookie.forEach(function (val) {
            var c = val;
            if (c.includes('zip')) {
                var zipVal = c.substring(c.indexOf('=') + 1, c.length);
                newdecodedCookie = Number(zipVal);
            }
        });
        return newdecodedCookie;
    };
    RetrieveCart.prototype.getCityValue = function (cookieVal) {
        var decodedCookie = cookieVal.split('|');
        var newdecodedCookie;
        decodedCookie.forEach(function (val) {
            var c = val;
            if (c.includes('city')) {
                newdecodedCookie = c.substring(c.indexOf('=') + 1, c.length);
            }
        });
        return newdecodedCookie;
    };
    RetrieveCart.prototype.getStateValue = function (cookieVal) {
        var decodedCookie = cookieVal.split('|');
        var newdecodedCookie;
        decodedCookie.forEach(function (val) {
            var c = val;
            if (c.includes('state')) {
                newdecodedCookie = c.substring(c.indexOf('=') + 1, c.length);
            }
        });
        return newdecodedCookie;
    };
    RetrieveCart.prototype.zipCodeMismatch = function () {
        var _this = this;
        this.payload = Utils.getCartResp();
        var currentLob = Utils.getCurrentLOB();
        if (currentLob &&
            this.payload &&
            currentLob.toUpperCase() === 'WIRELESS' && !this.payload.authUser) {
            var cookieVal = Utils.getCookie('attPersistantLocalization');
            var zipValue = this.getZipValue(cookieVal);
            var stateValue = this.getStateValue(cookieVal);
            var cityValue = this.getCityValue(cookieVal);
            if (this.payload.wirelessCart) {
                return (React.createElement("div", null, this.showCartModal()));
            }
            return (React.createElement("div", null,
                React.createElement(ui_components_1.Modal, { testId: 'Modal_Legal_Content', options: { center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                        show: this.state.showModal, showClose: true }, events: { onClose: this.onClose }, accessibilityText: "_Retrieve_Cart" },
                    React.createElement("div", { className: CartConfiguration_scss_1.rennyModalContainer },
                        React.createElement("div", { className: localStyles.mainHeadingZip },
                            React.createElement(ui_components_1.Label, { data: { text: this.retrieveCarttext.retrieve.titleLabel }, options: { className: CartConfiguration_scss_1.rennyModalTitle } })),
                        React.createElement("div", { className: localStyles.existdescLabelZip },
                            React.createElement(ui_components_1.Label, { data: {
                                    text: UtilityFunctions_1.utilCheckCMSContent(this.retrieveCarttext.retrieve, 'zipCodeMismatchLabel')
                                }, options: { size: LabelProps_1.LabelSizes.MEDIUMBODY } })),
                        React.createElement("div", { className: localStyles.chooseLocLabelZip },
                            React.createElement(ui_components_1.Label, { data: {
                                    text: UtilityFunctions_1.utilCheckCMSContent(this.retrieveCarttext.retrieve, 'chooseLocationLabel')
                                }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING15 } })),
                        React.createElement("div", { className: localStyles.radioLabelZip },
                            React.createElement(components_1.RadioGroup, { name: "", options: { elementsDirection: 'column', accordion: true, spacing: 15 }, testId: 'CHKT_CreateAAID_RGroup', 
                                // tslint:disable-next-line: jsx-no-lambda
                                onChange: function (value) {
                                    _this.setState({
                                        currentValue: value,
                                        isSubmitBtnDisabled: false,
                                    });
                                } },
                                React.createElement(components_1.RadioButton, { value: UtilityFunctions_1.utilCheckCMSContent(this.retrieveCarttext.retrieve, 'savedLocationTxt'), customLabel: false, card: true }),
                                React.createElement(components_1.RadioButton, { value: UtilityFunctions_1.utilCheckCMSContent(this.retrieveCarttext.retrieve, 'currentLocationTxt'), customLabel: false, card: true }, cityValue + ', ' + stateValue + ' ' + zipValue))),
                        React.createElement("div", { className: localStyles.retrieveButtonZip },
                            React.createElement(ui_components_1.Button, { data: {
                                    disabled: this.state.isSubmitBtnDisabled,
                                    text: this.retrieveCarttext.retrieve.titleLabel,
                                }, events: { onClick: this.submitZipCodeEvents }, options: { className: localStyles.buttonSize }, testId: utils_1.default('Button', '_contactInfo_Button') }),
                            React.createElement(ui_components_1.Button, { data: { text: this.retrieveCarttext.retrieve.cancelCTALabel }, events: this.cancelEvent, testId: utils_1.default('Link', '_cancel_Link'), options: {
                                    className: localStyles.buttonSize,
                                } }))))));
        }
        else {
            return (React.createElement("div", null, this.showCartModal()));
        }
    };
    RetrieveCart.prototype.submitZipCodeEvents = function () {
        if (this.state.currentValue === RetrieveCartProps_1.LocationTypes.SAVED) {
            this.setState({
                isSubmitBtnDisabled: true,
                showModal: false,
            });
            if (this.props && this.props.events) {
                this.props.events.onModalClose();
            }
        }
        else if (this.state.currentValue === RetrieveCartProps_1.LocationTypes.CURRENT) {
            // TBD in next US
        }
    };
    return RetrieveCart;
}(React.Component));
exports.default = RetrieveCart;
//# sourceMappingURL=RetrieveCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/cards/SaveRetrieveCart/RetrieveCart/RetrieveCart.js
// module id = 2277
// module chunks = 8